import { RouteObject } from "react-router-dom";
import { PROPOSAL, PROPOSAL_DETAIL, PROPOSAL_EDIT } from "constants/urls";

export default [
  {
    index: true,
    path: PROPOSAL,
    lazy: () => import("modules/proposal/pages/ProposalDashboard"),
  },
  {
    path: PROPOSAL_DETAIL,
    lazy: () => import("modules/proposal/pages/ProposalDetails"),
  },
  {
    path: PROPOSAL_EDIT,
    lazy: () => import("modules/proposal/pages/ProposalCreateEdit"),
  },
] as RouteObject[];
